<script setup lang="ts">
import { type User, FloatingBox, SlideTransition, globalOverlayContainer } from '#shared'
import { computed } from 'vue'
import { useEmojiByChar } from '#shared/state/use-emoji-by-char'

const { char, senders, reactionItemEl, isShown } = defineProps<{
  char: string
  senders: User[]
  reactionItemEl: HTMLElement | null
  isShown: boolean
}>()

const emojiByChar = useEmojiByChar()

const popupText = computed(() => {
  let sendersLabel = ''

  const [firstSender, secondSender, thirdSender] = senders

  if (senders.length === 1) sendersLabel = firstSender.displayName
  else if (senders.length === 2) sendersLabel = `${firstSender.displayName} and ${secondSender.displayName}`
  else if (senders.length === 3)
    sendersLabel = `${firstSender.displayName}, ${secondSender.displayName} and ${thirdSender.displayName}`
  else sendersLabel = `${firstSender.displayName}, ${secondSender.displayName} and ${senders.length - 2} others`

  const emoji = emojiByChar.value.get(char)
  const emojiName = emoji?.name ? emoji.name : char

  return `${sendersLabel} reacted with ${emojiName}`
})
</script>

<template>
  <Teleport :to="globalOverlayContainer">
    <SlideTransition :offsetY="-10">
      <FloatingBox
        v-if="isShown"
        horizontalPosition="center"
        :verticalOffset="-5"
        verticalPosition="top-outside"
        :targetEl="reactionItemEl"
      >
        <div :class="$style.root">
          <div :class="$style.icon">
            {{ char }}
          </div>

          <div :class="$style.text">
            {{ popupText }}
          </div>
        </div>
      </FloatingBox>
    </SlideTransition>
  </Teleport>
</template>

<style lang="scss" module>
.root {
  background-color: #1f1f22;
  border-radius: 4px;
  padding: 10px;
  display: flex;
  gap: 16px;
  border: 1px solid #404045;
  max-width: 250px;
}

.icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  transform: translateY(5px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.text {
  font-size: 14px;
}
</style>
